(function () {
    "use strict";

    angular.module("app").controller("FinishedAssistanceInListController", FinishedAssistanceInListController);

    FinishedAssistanceInListController.$inject = ["controllerDecorator", "assistanceInList", "assistanceInService",];
    function FinishedAssistanceInListController(controllerDecorator, assistanceInList,  assistanceInService) {
        
        const vm = this;
        controllerDecorator.Decorate(vm, ["navigation"]);

        vm.toggleDetail = toggleDetail;
        vm.downloadExcel = downloadExcel;
        vm.assistanceInResultCodes = assistanceInService.assistanceInResultCodes;

        activate();

        function activate() {

            const parsed = vm.ParsePrettyUrl();
            assistanceInList.GetFinished(
                parsed.id,
                r => {
                    vm.model = r.data;
                    vm.model.Requests.forEach(assistanceInService.addForeignPartnerInfo);
                },
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );
        }

        function downloadExcel() {
            vm.SetLoadingState(true);

            assistanceInList.DownloadExcel(
                vm.model.PublicId,
                angular.noop,
                vm.ShowError,
                () => vm.SetLoadingState(false),
                { responseType: "arraybuffer", }
            );
        }

        function toggleDetail(request) {
            if (vm.openRequest === request)
                vm.openRequest = null;
            else
                vm.openRequest = request;
        }
    }
})();